/**
 * Zoy Lookbook Hotspots — toggle tooltips
 */
(function () {
  'use strict';

  document.querySelectorAll('.zoy-lookbook').forEach(function (section) {
    var hotspots = section.querySelectorAll('[data-zoy-hotspot]');

    hotspots.forEach(function (hotspot) {
      var toggle = hotspot.querySelector('[data-zoy-hotspot-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = hotspot.classList.contains('is-open');
        // Close all others
        hotspots.forEach(function (h) { h.classList.remove('is-open'); });
        // Toggle this one
        if (!isOpen) hotspot.classList.add('is-open');
      });
    });

    // Click outside closes all
    document.addEventListener('click', function (e) {
      if (!section.contains(e.target)) {
        hotspots.forEach(function (h) { h.classList.remove('is-open'); });
      }
    });
  });
})();
